import { UserRole } from '@sphere/auth/domain';
import { DOCS_CATALOG, ROLE_DOCS_META } from './docs.catalog';
import {
  DOCS_SECTION_ORDER,
  type DocsArticle,
  type DocsSection,
  type RoleDocsMeta,
} from './docs.types';

export function getDocsForRole(role: UserRole): DocsArticle[] {
  return DOCS_CATALOG.filter((article) => article.roles.includes(role));
}

export function getArticleBySlug(slug: string): DocsArticle | undefined {
  return DOCS_CATALOG.find((article) => article.slug === slug);
}

export function canAccessArticle(slug: string, role: UserRole): boolean {
  const article = getArticleBySlug(slug);
  return Boolean(article?.roles.includes(role));
}

export function getRoleDocsMeta(role: UserRole): RoleDocsMeta {
  return ROLE_DOCS_META[role];
}

export function groupDocsBySection(
  articles: DocsArticle[]
): { section: DocsSection; articles: DocsArticle[] }[] {
  return DOCS_SECTION_ORDER.map((section) => ({
    section,
    articles: articles.filter((article) => article.section === section),
  })).filter((group) => group.articles.length > 0);
}

export function searchDocsForRole(
  role: UserRole,
  query: string
): DocsArticle[] {
  const normalized = query.trim().toLowerCase();
  const articles = getDocsForRole(role);
  if (!normalized) {
    return articles;
  }

  return articles.filter((article) => {
    const haystack = [
      article.title,
      article.summary,
      ...article.tags,
    ]
      .join(' ')
      .toLowerCase();
    return haystack.includes(normalized);
  });
}
